import { createAsyncThunk } from '@reduxjs/toolkit';
import { WebsitesAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  ICreateWebsitesDataDTO,
  ICreateWebsitesResponse,
  IDeleteWebsitesDTO,
  IDeleteWebsitesResponse,
  IGetWebsitesOptionsDTO,
  IReorderWebsitesDTO,
  IUpdateWebsitesDataDTO,
  IUpdateWebsitesResponse,
  TGetWebsitesResponse,
} from '@/models/websites.model';
import { SLICE_NAME } from './models';

export const getWebsites = createAsyncThunk<
  TGetWebsitesResponse,
  IGetWebsitesOptionsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getWebsites`,
  async (params) => {
    const response = await WebsitesAPI.getWebsites(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createWebsite = createAsyncThunk<
  ICreateWebsitesResponse,
  ICreateWebsitesDataDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/createWebsite`,
  async (data) => {
    const response = await WebsitesAPI.createWebsite(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateWebsite = createAsyncThunk<
  IUpdateWebsitesResponse,
  IUpdateWebsitesDataDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateWebsite`,
  async (data) => {
    const response = await WebsitesAPI.updateWebsite(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteWebsite = createAsyncThunk<
  IDeleteWebsitesResponse,
  IDeleteWebsitesDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/deleteWebsite`,
  async (data) => {
    await WebsitesAPI.deleteWebsite(data);
    return data.id as string;
  },
  { serializeError: formatApiError },
);

export const reorderWebsites = createAsyncThunk<
  TGetWebsitesResponse,
  IReorderWebsitesDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/reorderWebsites`,
  async (data) => {
    const response = await WebsitesAPI.reorderWebsites(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
